import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../hooks/useDebouncedCallback'
import { useSendAsEmailForm } from '../../../../../../contexts/sendAsEmailFormContext'
import { useTrackSendAsEmail } from '../../../../../../hooks/useTrackSendAsEmail'

export const EmailSubject = (): ReactElement => {
  const { t } = useTranslation()
  const { sendAsEmailForm } = useSendAsEmailForm()
  const { trackSendAsEmail } = useTrackSendAsEmail()
  const { FormItem } = sendAsEmailForm

  const handleDebouncedEmailSubjectInput = useDebouncedCallback((value: string) =>
    trackSendAsEmail('Subject modified', { newSubject: value }),
  )

  return (
    <FormItem
      label={t('external_invoices.send_as_email.modal.form.field.subject.label')}
      name="emailSubject"
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Input
            {...rest}
            onChange={(subject) => {
              onChange(subject)
              handleDebouncedEmailSubjectInput(subject.target.value)
            }}
            size="sm"
          />
        )
      }}
    />
  )
}
